import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { I18nModule } from '@spartacus/core';
import { UserModalComponent } from './user-modal.component';

@NgModule({
  declarations: [UserModalComponent],
  imports: [
    CommonModule,
    I18nModule,
    BrowserModule,
  ],
  providers: [
  ],
})
export class UserModalModule { }
